[
  {
    "code": "ZA-EC",
    "name": "Eastern Cape"
  },
  {
    "code": "ZA-FS",
    "name": "Free State"
  },
  {
    "code": "ZA-GT",
    "name": "Gauteng"
  },
  {
    "code": "ZA-NL",
    "name": "Kwazulu-Natal"
  },
  {
    "code": "ZA-LP",
    "name": "Limpopo"
  },
  {
    "code": "ZA-MP",
    "name": "Mpumalanga"
  },
  {
    "code": "ZA-NW",
    "name": "North-West"
  },
  {
    "code": "ZA-NC",
    "name": "Northern Cape"
  },
  {
    "code": "ZA-WC",
    "name": "Western Cape"
  }
]